import Recat, { useImperativeHandle, useRef, useState, useEffect } from 'react'
import { InputNumber, message, Spin, } from 'antd'
import { SGeneralForms } from 'shj-components'
import { httpCompanyList, httpDictServTenant } from '@/services/fmsServices'
import { getBankList, getBankBranchList } from '@/services/fmsConfig'
import { searchBankBranch } from '@/services'
export const AddOrEditForm = Recat.forwardRef((props: any, ref) => {
    const { editData } = props;
    const formRef: any = useRef()
    const [spinning, setSpinning] = useState(false)
    const [loading, setLoading] = useState(false)
    const reqMeg = '不能为空'
    useImperativeHandle(ref, () => ({
        validateFields: () => formRef.current?.onFormRef()?.validateFields(),
    }));
    useEffect(() => {
        initFn()
    }, [])
    const initFn = async () => {
        if (editData) {
            // getBankBranchNumList(editData?.bankType)
            formRef.current?.updateState({
                bankBranchList: [{
                    branchName: editData?.bankBranchName,
                    branchCode: editData?.bankNetworkNumber,
                }]
            });
            formRef.current?.onFormRef()?.setFieldsValue({ ...editData, overPickAccount: editData?.overPickAccount == 1 ? true : false, companyPaymentAccountFlag: editData?.companyPaymentAccountFlag == 1 ? true : false, onlinePaymentAccount: editData?.onlinePaymentAccount == 1 ? true : false, })
        }
    }
    const getBankBranchNumList = (code, value=null ) => {
        setLoading(true)
        if(!value){
            formRef.current?.onFormRef()?.setFieldsValue({bankNetworkNumber: null}) //清空开户行网点名称
        }
        formRef.current?.updateState({
            bankBranchList: []
        });
        searchBankBranch({
            bankCode: code,
            keyword: value
        }).then((res) => {
            setLoading(false)
            for(let m of res){
                m.branchName = m.BRANCH_NAME || m.branchName
                m.branchCode = m.BRANCH_CODE || m.branchCode
            }
            formRef.current?.updateState({
                bankBranchList: res
            });
        }).catch(err => {
            setLoading(false)
        })
    }
    const getOptions = async () => {
        setSpinning(true)
        const bankTypeList: any = await getBankList({
            orderBys: [
                {
                    columnName: '',
                    asc: false
                }
            ]
        })
        const receiptMethodList: any = await httpDictServTenant({
            parentKey: 'bankSettleType',
            enabled: 1,
        })
        let orgCompanyList: any = await httpCompanyList()
        setSpinning(false)
        return Promise.resolve({
            bankTypeList,
            receiptMethodList,
            orgCompanyList
        })
    }
    return (
        <Spin spinning={spinning}>
            <SGeneralForms
                ref={formRef}
                layout="vertical"
                httpOptionsFn={getOptions}
                configs={[
                    {
                        formItem: [
                            { label: 'id', name: 'id', hidden: true },
                            {
                                label: '公司名称',
                                name: 'companyOrgId',
                                spanCol: 12,
                                type: 'select',
                                data: 'orgCompanyList',
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    fieldNames: { value: 'orgId', label: 'companyName' },
                                },
                            },
                            {
                                label: '银行名称',
                                name: 'bankType',
                                spanCol: 12,
                                type: 'select',
                                data: 'bankTypeList',
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    fieldNames: { value: 'bankCode', label: 'bankName' },
                                    onChange: (value) => { getBankBranchNumList(value) }
                                },
                            },
                            {
                                label: '开户行网点名称',
                                // name: 'bankBranchName',
                                name: 'bankNetworkNumber',
                                spanCol: 12,
                                type: 'select',
                                required: true,
                                data: 'bankBranchList',
                                rules: [{ required: true, message: reqMeg }],
                                isDeps: true,
                                deps: [{ name: 'bankType', value: true }],
                                comConfig: {
                                    loading: loading,
                                    fieldNames: { value: 'branchCode', label: 'branchName' },
                                    onSearch: (value:any)=>{
                                        const bankCode = formRef?.current?.onFormRef()?.getFieldValue('bankType')
                                        getBankBranchNumList(bankCode, value)
                                    },
                                    // filterOption: (inputValue, option) => {
                                    //     const lowerInputValue = inputValue?.toLowerCase();
                                    //     const lowerLabel = option?.branchName?.toLowerCase();
                                    //     // 跨字模糊搜索：检查输入值的每个字符是否都在标签中出现
                                    //     return [...lowerInputValue].every(char => lowerLabel.includes(char));
                                    // },
                                    showSearch: true,
                                    filterOption: false,
                                    // notFoundContent: (<div>正在加载中...</div>)
                                },
                            },
                            {
                                label: '银行卡号',
                                name: 'cardNo',
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                spanCol: 12,
                                comConfig: {
                                    maxLength: 30,
                                },
                            },
                            {
                                label: '银行账户名称',
                                name: 'accountName',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 30,
                                },
                            },
                            {
                                label: '银行地址',
                                name: 'address',
                                spanCol: 12,
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 50,
                                },
                            },
                            {
                                label: '结算方式',
                                name: 'receiptMethodCode',
                                spanCol: 12,
                                type: 'select',
                                data: 'receiptMethodList',
                                comConfig: {
                                    fieldNames: { value: 'priKey', label: 'name' },
                                },
                            },
                            {
                                label: '排序',
                                name: 'ordinal',
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                spanCol: 12,
                                children: (
                                    <InputNumber placeholder="输入排序" maxLength={4} min={1} parser={value => value ? value.replace(/\D/g, '') : ''}
                                        formatter={value => value ? `${value}`.replace(/\D/g, '') : ''} />
                                )
                            },
                            {
                                label: '是否超额保证金收款账户',
                                name: 'overPickAccount',
                                type: 'switch',
                                spanCol: 12,
                                comConfig: {
                                    checkedChildren: '是',
                                    unCheckedChildren: '否',
                                },
                            },
                            {
                                label: '是否是在线收款',
                                name: 'onlinePaymentAccount',
                                type: 'switch',
                                spanCol: 12,
                                comConfig: {
                                    checkedChildren: '是',
                                    unCheckedChildren: '否',
                                },
                            },
                            {
                                label: '是否是公司付款账户',
                                name: 'companyPaymentAccountFlag',
                                type: 'switch',
                                spanCol: 12,
                                comConfig: {
                                    checkedChildren: '是',
                                    unCheckedChildren: '否',
                                },
                            },
                            {
                                label: '备注',
                                type: 'textarea',
                                name: 'remark',
                                required: true,
                                rules: [{ required: true, message: reqMeg }],
                                comConfig: {
                                    maxLength: 100,
                                },
                                spanCol: 24,
                            },
                        ],
                    },
                ]}
            />
        </Spin>
    )
})
